import { useTheme } from '@mui/styles';

export const useAvatarCellStyles = () => {
  const theme = useTheme();

  return {
    dataCell: {
      display: 'flex',
    },
    text: {
      marginTop: 'auto',
      marginBottom: 'auto',
      paddingLeft: theme.spacing(),
    },
  };
};
